import { Injectable, inject } from '@angular/core';
import { Store } from '@ngrx/store';
import * as AuthActions from '@/app/store/auth/auth.actions';

/**
 * App Initializer Service
 * Được gọi khi ứng dụng khởi động để initialize các state cần thiết
 */
@Injectable({
  providedIn: 'root'
})
export class AppInitializerService {
  private store = inject(Store);

  /**
   * Initialize app - dispatch action để load auth state từ storage và refresh từ server nếu cần
   */
  initializeApp(): Promise<void> {
    return new Promise((resolve) => {
      // Dispatch initialize auth action để load từ storage và refresh từ server
      this.store.dispatch(AuthActions.initializeAuth());

      // Resolve immediately - auth effects sẽ handle việc refresh async
      resolve();
    });
  }
}

/**
 * Factory function để sử dụng với APP_INITIALIZER
 */
export function appInitializerFactory(appInitializer: AppInitializerService): () => Promise<void> {
  return () => appInitializer.initializeApp();
}
